<app-listview-gridview-header></app-listview-gridview-header>

<div class="listviewGridviewContainer">
  <ng-container *ngIf="noRecordFound; else viewContent">
    <div class="no-results-container" >
      <img
        src="../../../assets/img/no-data.png"
        class="no-results-image"
        alt="No data available"
      />
      <div class="no-results-message color_black">
        <span class="font_20 weight_800"
          >Sorry – The search found zero results. Why…</span
        >
        <ul class="no-results-list text_start">
          <li>
            <span class="font_20 weight_500"
              >Make sure you have selected the correct search criteria</span
            >
          </li>
          <li>
            <span class="font_20 weight_500"
              >Make sure that all words are spelled correctly</span
            >
          </li>
          <li>
            <span class="font_20 weight_500">Try different keywords</span>
          </li>
          <li>
            <span class="font_20 weight_500">Try more general keywords</span>
          </li>
        </ul>
      </div>
      <!-- Back to search button -->
      <!-- <button class="btn-back-to-search" (click)="goBackToSearch()">
        Back to Search
      </button> -->
    </div>
  </ng-container>

  <ng-template #viewContent>
    <ng-container *ngIf="currViewType === 'listView'">
      <app-list-view></app-list-view>
    </ng-container>
    <ng-container *ngIf="currViewType === 'gridView'">
      <app-grid-view></app-grid-view>
    </ng-container>
  </ng-template>
</div>
